(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .controller('RuoloFunzioneDialogController', RuoloFunzioneDialogController);

    RuoloFunzioneDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'RuoloFunzione', 'Operazione', 'Ruolo', 'Funzione'];

    function RuoloFunzioneDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, RuoloFunzione, Operazione, Ruolo, Funzione) {
        var vm = this;

        vm.ruoloFunzione = entity;
        vm.clear = clear;
        vm.save = save;
        vm.operaziones = Operazione.query();
        vm.ruolos = Ruolo.query();
        vm.funziones = Funzione.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.ruoloFunzione.id !== null) {
                RuoloFunzione.update(vm.ruoloFunzione, onSaveSuccess, onSaveError);
            } else {
                RuoloFunzione.save(vm.ruoloFunzione, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('ordiniApp:ruoloFunzioneUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
